import { Box, BoxProps, Button } from "@vinomofo/components";
import { useEffect, useState } from "react";

import { VinoDataOffer } from "../../types/vino-data-types";
import styled from "styled-components";
import useAuth from "../../hooks/use-auth";
import { useCart } from "../../hooks/use-cart";
import useOneClickCheckout from "../../hooks/use-one-click-checkout";
import useScreenSize from "../../hooks/use-screen-size";

export interface OfferDetails extends BoxProps {
  id?: string;
  productId: string;
  offer: VinoDataOffer;
  isSoldOut: boolean;
}

const ButtonStyled = styled(Button)`
  margin-bottom: 40px;
  @media ${({ theme }) => theme.mq.max.mobile} {
    width: 100%;
    margin: auto 20px 20px;
  }
  &.btn-is-loading {
    color: rgba(255, 255, 255, 0);
    background-color: #48a90f;
    border-color: #48a90f;
    transition: all 0.5s;
    &:hover {
      color: transparent;
    }
    &::before {
      content: "Loading ...";
      color: rgba(255, 255, 255, 0.7);
      position: absolute;
      left: 0;
      right: 0;
      animation: moveUp 0.5s;
    }
  }
`;

export const InlineAddToCart = ({
  id,
  productId,
  offer,
  isSoldOut,
  marginTop = ["10px", "0px"],
  paddingTop = ["20px", "40px", "70px"],
}: OfferDetails): JSX.Element => {
  const { addItem, isLoading } = useCart();
  const {
    isProcessing,
    isBuying,
    isRedirecting: oneClickCheckoutRedirecting,
  } = useOneClickCheckout();
  const { user } = useAuth();
  const userAppMeta = user?.["https://www.vinomofo.com/app_metadata"];
  const [productLoading, setProductLoading] = useState({});
  const { isMobile } = useScreenSize();
  
  const handleAddButtonClick = () => {
    const customerId =
      userAppMeta?.[`BIGCOMMERCE_${process.env.GATSBY_VM_MARKET}_CUSTOMER_ID`];
    setProductLoading((oldState) => ({ ...oldState, [productId]: true }));
    addItem(productId, offer, customerId, "Page Bottom", () => {
      setProductLoading((oldState) => ({ ...oldState, [productId]: false }));
    });
  };

  // useEffect(() => {
  //   if (productLoading[productId] && !isLoading)
  //     setProductLoading((oldState) => ({ ...oldState, [productId]: false }));
  // }, [isLoading, productLoading, productId]);

  const btnLoading = productLoading[productId];
  const isDisabled = isBuying || isProcessing || oneClickCheckoutRedirecting;

  return (
    <Box
      id={id}
      display="flex"
      justifyContent="space-around"
      backgroundColor="#FFF"
      paddingBottom="0"
      marginTop={marginTop}
      paddingTop={paddingTop}
    >
      {!isSoldOut ? (
        !isMobile && (
          <ButtonStyled
            variant="primary"
            disabled={btnLoading || isDisabled}
            type="submit"
            minWidth={200}
            onClick={handleAddButtonClick}
            className={btnLoading ? "btn-is-loading" : ""}
          >
            Add to cart
          </ButtonStyled>
        )
      ) : (
        <ButtonStyled
          variant="primary"
          disabled={true}
          type="submit"
          minWidth={250}
        >
          Sorry, Sold Out
        </ButtonStyled>
      )}
    </Box>
  );
};
